var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showLoader)?_c('div',{staticClass:"loader"},[_c('gl-loading-icon',{attrs:{"label":"Loading...","size":"xl","color":"light","inline":false}}),_c('p',[_vm._v("Loading...")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }